import ApiService from "@/common/api.service"

export const DisciplinesService = {
    create(params) {
        return ApiService.post("disciplines/add", params);
    },
    update(slug, params) {
        return ApiService.update("disciplines", slug, params);
    },

}